// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React from "react";
import moment from "moment";

import { Filters as StyledFilters, Label, Button, LastUpdated } from "./styles";
import Process from "./Process";
import Department from "./Department";
import Groups from "./Groups";
import { toggleTotal, toggleAverage } from "src/actions/userAnalytics";

import type { AppState } from "src/types";

type Props = {
  showTotal: boolean,
  showAverage: boolean,
  readCountComputedAt: string,
  _toggleTotal: Function,
  _toggleAverage: Function
};

const Filters = ({
  showTotal,
  showAverage,
  readCountComputedAt,
  _toggleTotal,
  _toggleAverage
}: Props) => (
  <StyledFilters>
    <Label>{i18n.t(k.FILTERS1)}</Label>
    <Process />
    <Department />
    <Groups />
    <Button active={showTotal} type="button" onClick={_toggleTotal}>
      {i18n.t(k.SHOW_TOTAL)}
    </Button>
    <Button active={showAverage} type="button" onClick={_toggleAverage}>
      {i18n.t(k.SHOW_AVERAGE)}
    </Button>
    <LastUpdated>
      <strong>{i18n.t(k.LAST_UPDATED)}</strong>
      <span>
        {readCountComputedAt
          ? moment(readCountComputedAt).format(i18n.t(k.MMM_DD_YYYY_HH_MM_A))
          : null}
      </span>
    </LastUpdated>
  </StyledFilters>
);

const mapStateToProps = ({ app }: { app: AppState }) => ({
  showTotal: app.userAnalytics.showTotal,
  showAverage: app.userAnalytics.showAverage,
  readCountComputedAt: app.userAnalytics.readCountComputedAt
});

export default connect(mapStateToProps, {
  _toggleTotal: toggleTotal,
  _toggleAverage: toggleAverage
})(Filters);
